import { Injectable, signal, computed } from '@angular/core';

/**
 * Global loader service.
 * Counter-based so overlapping requests don't cancel each other:
 * 2 requests start → count=2 → both must finish → count=0 → loader hides.
 */
@Injectable({ providedIn: 'root' })
export class LoaderService {
  private _count = signal(0);

  /** True whenever any HTTP request is in flight */
  isLoading = computed(() => this._count() > 0);

  start() { this._count.update(n => n + 1); }
  stop()  { this._count.update(n => Math.max(0, n - 1)); }
}
